import { combineReducers } from "redux";
import changeStep from "./signUp.reducer";
import product from "./product.reducer"
import escapeBucksReducers from "./escapeBuck.reducer";


const rootReducers = combineReducers(
    {
        changeStep,
        product,
        escapeBucksRedux: escapeBucksReducers
    }
)
export default rootReducers